import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import IconButton from 'material-ui/IconButton';
// import ThumbUp from 'material-ui/svg-icons/action/thumb-up';
// import ThumbDown from 'material-ui/svg-icons/action/thumb-down';
// import { reviewApprove as reviewApproveAction, reviewReject as reviewRejectAction } from './reviewActions';
import MapsDirectionsCar from 'material-ui/svg-icons/maps/directions-car';
import ContentSend from 'material-ui/svg-icons/content/send';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment'
import { push as pushAction } from 'react-router-redux';
import { 
	showNotification as showNotificationAction,
} from 'admin-on-rest';
import { refreshView as refreshViewAction } from '../actions/uiActions'
import { dateString } from '../util'
import {
	accountTransmit as accountTransmitAction,
 	accountRelease as accountReleaseAction
} from '../actions/AccountActions';

import DateTimePicker from 'material-ui-datetimepicker';
import DatePicker from 'material-ui/DatePicker'
import DatePickerDialog from 'material-ui/DatePicker/DatePickerDialog'
import TimePickerDialog from 'material-ui/TimePicker/TimePickerDialog';
import FlatButton from 'material-ui/FlatButton'
import Dialog from 'material-ui/Dialog'
import AlertWarning from 'material-ui/svg-icons/alert/warning'
import ReactTooltip from 'react-tooltip'

class ReleaseButton extends Component {
	state = {
		open: false,
		dateTime: new Date(),
		dateInsuranceDate: '',
	};

	setDate = dateTime => this.setState({ dateTime })
	setInsuranceDate = (_, dateInsuranceDate) => this.setState({ dateInsuranceDate })

	handleOpen = () => {
		this.setState({ 
			open: true,
			dateTime: new Date(),
			dateInsuranceDate: this.props.record.fields.insurance_policy_date ? new Date( this.props.record.fields.insurance_policy_date ) : '',
		})
	};

	handleSave = () => {
		this.confirm()
		this.setState({open: false});
	};

	handleCancel = () => {
		this.setState({open: false});
	};

	confirm = () => {
		const { accountRelease, record } = this.props;
		record.fields.insurance_policy_date = moment( this.state.dateInsuranceDate ).format( 'MM/DD/YYYY' )
		accountRelease(record.id, record, dateString( this.state.dateTime ) )
	}

	render() {
		const actions = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.handleCancel}
			/>,
			<FlatButton
				label="Confirm Release"
				primary={true}
				onClick={this.handleSave}
				disabled={ ! this.state.dateInsuranceDate }
			/>,
		];

		return (
			<div style={{ display: 'inline-block' }}>
				<RaisedButton label="Release" icon={<MapsDirectionsCar />} secondary={true} onClick={this.handleOpen} style={{ margin: 10 }} {...this.props.options} />
				<Dialog
					title="Enter Release Details"
					actions={actions}
					modal={false}
					open={this.state.open}
					onRequestClose={this.handleCancel}
				>
					<DateTimePicker
						floatingLabelText="Enter Date of Release"
						value={this.state.dateTime}
				        onChange={this.setDate}
				        DatePicker={DatePickerDialog}
				        TimePicker={TimePickerDialog}
						format="MM/DD/YYYY h:mm a"
				      />
					<DatePicker
						floatingLabelText="Insurance Policy Date"
						errorText={ this.state.dateInsuranceDate ? '' : 'This is required for release' }
						formatDate={ date => moment( date ).format( 'MM/DD/YYYY' ) }
						value={this.state.dateInsuranceDate}
						onChange={this.setInsuranceDate}
						container="inline" 
					/>
				</Dialog>
			</div>
		);
	}
}

class TransmitButton extends Component {
	state = {
		open: false,
		dateTime: new Date(),
	};

	setDate = (dateTime) => this.setState({ dateTime })

	handleOpen = () => {
		this.setState({ dateTime: new Date() })
		this.setState({ open: true })
	};

	handleSave = () => {
		this.confirm()
		this.setState({open: false});
	};

	handleCancel = () => {
		this.setState({open: false});
	};

	confirm = () => {
		const { accountTransmit, record } = this.props;
		accountTransmit(record.id, record, dateString( this.state.dateTime ) )
	}

	render() {
		const actions = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.handleCancel}
			/>,
			<FlatButton
				label="Confirm Transmittal"
				primary={true}
				onClick={this.handleSave}
			/>,
		];

		return (
			<div style={{ display: 'inline-block' }}>
				<RaisedButton label="Transmit" icon={<ContentSend />} primary={true} onClick={this.handleOpen} style={{ margin: 10 }} {...this.props.options} />
				{ this.props.record.fields.transmittal_rejection_reason && 
					<span>
						<ReactTooltip />
						<style>{ '[data-id="tooltip"] { max-width: 400px; }' }</style>
						<AlertWarning 
							data-tip={ "Transmittal was rejected: " + this.props.record.fields.transmittal_rejection_reason } 
							data-multiline="true"
							style={ { 
								color: "#d50000",
								verticalAlign: "middle",
								marginTop: "-4px",
							} }
						/>
					</span>
				}
				<Dialog
					title="Enter Date of Bank Receipt"
					actions={actions}
					modal={false}
					open={this.state.open}
					onRequestClose={this.handleCancel}
					>
					<DateTimePicker
						value={this.state.dateTime}
				        onChange={this.setDate}
				        DatePicker={DatePickerDialog}
				        TimePicker={TimePickerDialog}
						format="MM/DD/YYYY h:mm a"
				      />
				</Dialog>
			</div>
		);
	}
}

class DCButtons extends Component {

	handleComplyDocs = () => {
		const { push, basePath, record } = this.props;
		push( `${basePath}/${record.id}?tab=1` )
	}

    render() {
        const { record } = this.props;
		const { fields } = record;
		let releaseButton, transmittedButton, complyButton = null;
		if ( ! fields.is_released ) {
			releaseButton = <ReleaseButton {...this.props}/>
		}
		if ( ! fields.is_transmitted ) {
			transmittedButton = <TransmitButton disabled={!! fields.has_pending_docs} {...this.props}/>
		}
		// if ( ! fields.pending_docs ) {
			// transmittedButton = <RaisedButton label="Transmit" icon={<ContentSend />} primary={true} onClick={this.handleReject} style={{ margin: 10 }} />
		// } else {
			// complyButton = <RaisedButton label="Comply Pending Docs" icon={<AlertWarning />} primary={true} onClick={this.handleComplyDocs} style={{ margin: 10 }} />
		// }
        return (
            <span>
				{releaseButton}
				{complyButton}
				{transmittedButton}
            </span>
        );
    }
}
// <IconButton onClick={this.handleApprove} disabled={record.status === 'accepted'}><ThumbUp color="#00bcd4" /></IconButton>
// <IconButton onClick={this.handleReject} disabled={record.status === 'rejected'}><ThumbDown color="#00bcd4" /></IconButton>

DCButtons.propTypes = {
    record: PropTypes.object,
	refreshView: PropTypes.func,
	showNotification: PropTypes.func,
	accountTransmit: PropTypes.func,
	accountRelease: PropTypes.func,
	push: PropTypes.func,
	insurancePolicyDate: PropTypes.string,
    // reviewApprove: PropTypes.func,
    // reviewReject: PropTypes.func,
};

export default connect(null, {
    // reviewApprove: reviewApproveAction,
    // reviewReject: reviewRejectAction,
	refreshView: refreshViewAction,
	showNotification: showNotificationAction,
	accountTransmit: accountTransmitAction,
	accountRelease: accountReleaseAction,
	push: pushAction,
})(DCButtons);

// export default connect(null, {
//     showNotification: showNotificationAction,
// })(ApproveButton);



// WEBPACK FOOTER //
// ./src/DCAccount/DCButtons.js